(function() {
  const bar = document.getElementById('quick-buy-bar');
  const addToCartBtn = document.querySelector('[name="add"]');
  let selectedVariantId = null;

  if (!bar) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      bar.style.display = entry.isIntersecting ? 'none' : 'block';
    });
  }, { threshold: 0 });

  if (addToCartBtn) observer.observe(addToCartBtn);

  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      selectedVariantId = this.dataset.variantId;
    });
  });

  const firstBtn = document.querySelector('.size-btn:not([disabled])');
  if (firstBtn) {
    firstBtn.classList.add('active');
    selectedVariantId = firstBtn.dataset.variantId;
  }

  document.getElementById('quick-buy-btn')?.addEventListener('click', function() {
    if (!selectedVariantId) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
    }).then(() => { window.location.href = '/cart'; });
  });
})();
